import { createFileRoute } from "@tanstack/react-router";
import TmsForTreatmentResistantDepression from "@/pages/TmsForTreatmentResistantDepression";
export const Route = createFileRoute("/tms-for-treatment-resistant-depression")(
  {
    component: RouteComponent,
    head() {
      return {
        meta: [
          {
            title:
              "TMS For Treatment Resistant Depression | Neuro Wellness TMS",
          },
          {
            name: "description",
            content:
              "TMS for treatment-resistant depression in Coral Springs, FL. Learn how TMS and SAINT TMS help when antidepressants haven’t been enough Free consultation.",
          },
          {
            property: "og:title",
            content:
              "TMS For Treatment Resistant Depression | Neuro Wellness TMS",
          },
          {
            property: "og:description",
            content:
              "TMS for treatment-resistant depression in Coral Springs, FL. Learn how TMS and SAINT TMS help when antidepressants haven’t been enough Free consultation.",
          },
          {
            property: "og:url",
            content:
              "https://neurowellnesstms.com/tms-for-treatment-resistant-depression",
          },
          {
            property: "og:type",
            content: "website",
          },
          {
            name: "twitter:card",
            content: "summary_large_image",
          },
        ],
        links: [
          {
            rel: "canonical",
            href: "https://neurowellnesstms.com/tms-for-treatment-resistant-depression",
          },
        ],
      };
    },
  },
);
function RouteComponent() {
  return <TmsForTreatmentResistantDepression />;
}
